import { GMapService } from './services/gmap.service'
import { AgmCoreModule } from 'angular2-google-maps/core'
import { BrowserModule } from '@angular/platform-browser'
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core'
import { HttpModule } from '@angular/http'
import { AppRoutingModule } from './auth.routes'
import { SharedModule } from './modules/shared.module'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { QuillModule } from 'ngx-quill'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppComponent } from './app.component';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		AppRoutingModule,
		QuillModule,
		SharedModule.forRoot(),
		NgbModule.forRoot(),  
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyD5bdQ5XlStVqwEORRTf8sIFXPwZpeS6lw'
		}),
		HttpModule
	],
	schemas: [ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ],

	providers: [GMapService],
	bootstrap: [AppComponent]
})

export class AppModule { }


// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/app.module.ts